import instance from './axiosInstance';

const routerPrefix = '/alerts/manual';

export function getAlerts(options = {}) {
  return instance.get(`${routerPrefix}`, options);
}

export function getEvent(eventId, options = {}) {
  return instance.get(`${routerPrefix}/event/${eventId}`, options);
}

export function getEventsByAlert(alertId, options = {}) {
  return instance.get(`${routerPrefix}/${alertId}/events`, options);
}
